import type { OutlookSpaceAsset, TimeStreamAssets } from 'owa-timestream-types';
import upsertAsset from './upsertAsset';

export default function upsertAssets(
    assets: TimeStreamAssets,
    outlookSpaceAssets: OutlookSpaceAsset[],
    fullSync: boolean
) {
    for (const outlookSpaceAsset of outlookSpaceAssets) {
        upsertAsset(assets, outlookSpaceAsset, fullSync);
    }
}
